import React from 'react';
import { Mail, MessageSquare, Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#fffefc] text-[#2D1810] py-24 px-6 md:px-12 lg:px-24 border-t border-[#E8DFD8]" data-id="element-25">
      <div className="max-w-7xl mx-auto" data-id="element-26">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-27">
          <div className="md:col-span-2" data-id="element-28">
            <div className="mb-6" data-id="element-29">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3N41fDpegCrAJ1F4sfjWft/Screenshot_2025-11-25_at_19.25.33.png" alt="Hermo" className="h-8" data-id="element-30" />
            </div>
            <p className="text-[#6B5244] mb-6" data-id="element-31">
              The AI agent that brings more balance to your work and personal
              life
            </p>
            <div className="flex space-x-4" data-id="element-32">
              <a href="#" className="text-[#6B5244] hover:text-[#553116] transition-colors" data-id="element-33">
                <Linkedin size={20} data-id="element-34" />
              </a>
              <a href="#" className="text-[#6B5244] hover:text-[#553116] transition-colors" data-id="element-35">
                <Instagram size={20} data-id="element-36" />
              </a>
              <a href="#" className="text-[#6B5244] hover:text-[#553116] transition-colors" data-id="element-37">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-38">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-39" />
                </svg>
              </a>
            </div>
          </div>
          <div className="md:col-start-4" data-id="element-40">
            <h3 className="font-semibold text-lg mb-4" data-id="element-41">Company</h3>
            <ul className="space-y-3" data-id="element-42">
              <li data-id="element-43">
                <a href="#" className="text-[#6B5244] hover:text-[#553116] transition-colors" data-id="element-44">
                  About Us
                </a>
              </li>
              <li data-id="element-45">
                <a href="#" className="text-[#6B5244] hover:text-[#553116] transition-colors" data-id="element-46">
                  Privacy
                </a>
              </li>
              <li data-id="element-47">
                <a href="#" className="text-[#6B5244] hover:text-[#553116] transition-colors" data-id="element-48">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-[#E8DFD8] flex flex-col md:flex-row justify-between items-center" data-id="element-49">
          <p className="text-[#6B5244] mb-4 md:mb-0" data-id="element-50">
            © {new Date().getFullYear()} Hermo AI. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-51">
            <a href="#" className="text-[#6B5244] hover:text-[#553116] transition-colors flex items-center" data-id="element-52">
              <Mail size={16} className="mr-2" data-id="element-53" />
              <span data-id="element-54">Contact Us</span>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}